<adaa-data-table
    #adaaDataTable
    apiName="getAllV2"
    titleHeader="formulas.formula_console_icon"
    apiPrefix="formulas"
    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.FORMULAS"
    [enableEditAction]="true"
    [enableDeleteAction]="true"
    [enableViewAction]="true"
    [customActionButtons]="customButtons()"
    [enableAdd]="true"
    [itemTypeId]="Constants.CONSTANT_PERMISSIONS.FORMULAS"
    (addNewClicked)="addNewClicked()"
    (actionClicked)="getAction($event)"
></adaa-data-table>
